import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const data = [
    { TimePoint: 0, OD: 0.498, 'SDS': 70},
    { TimePoint: 24, OD: 0.601, 'SDS': 168.28},
    { TimePoint: 48, OD: 0.567, 'SDS': 158.76},
    { TimePoint: 72, OD: 0.597, 'SDS': 161.16},
    { TimePoint: 120, OD: 0.578, 'SDS': 161.8},
    { TimePoint: 148, OD: 0.64, 'SDS': 179},
    { TimePoint: 172, OD: 0.64, 'SDS': 174.72},
    { TimePoint: 196, OD: 0.641, 'SDS': 179.48},
];

function Figure9() {
  return (
    <div>
      <br></br>
      <p> <u>Figure 9: Culture OD evolution and Volume of SDS added over time (D2 domain) </u></p>
      <LineChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="TimePoint" type="number" label={{ value: 'TimePoint (hours)', position: 'BottomLeft' }}/>
        <YAxis yAxisId="left" label={{ value: 'OD (unitless)', angle: -90, position: 'left' }}/>
        <YAxis
          yAxisId="right"
          orientation="right"
          label={{ value: 'SDS (μL)', angle: -90, position: 'right' }}
        />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="OD" stroke="blue" yAxisId="left"/>
        <Line type="monotone" dataKey="SDS" stroke="red" yAxisId="right" />
        
      </LineChart>
    </div>
  );
}

export default Figure9;